import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';
const Tier = ({ deviation, width, height, className, responsive, style, showTierPromotionTooltip })=>{
    const { t } = useTranslation();
    const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    const biData = getBiDataForTierLink(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        style: _object_spread({
            width,
            height
        }, style),
        className: classnames(s['root'], className)
    }, showTierPromotionTooltip ? /*#__PURE__*/ React.createElement(TierPromotionCardWithFellaTooltip, {
        deviation: deviation,
        width: width,
        height: height
    }) : /*#__PURE__*/ React.createElement(TierPromotionCard, {
        deviation: deviation,
        width: width,
        height: height,
        verticalLayout: responsive
    }), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['link-overlay'],
        biData: biData,
        "aria-label": a11yLabel,
        href: Url.userSubscriptionsPath({
            username: deviation.author.username,
            tierDeviationId: deviation.deviationId,
            tierContentType: 'deviations'
        })
    }, /*#__PURE__*/ React.createElement("span", null)));
};
Tier.displayName = 'TierThumb';
export default Tier;
